import { thor } from "../typings/thor";

export const getOrderNbr = (item: thor.ItemGet): string =>
    [item.meta?.order_number?.primary, item.meta?.order_number?.secondary].filter(Boolean).join("-");
